import React from "react";
import { useLocation } from "react-router-dom";
import MyNavLink from "../MyNavLink";
import style from "./style.less";

function getTabClass(linkPath, locationPath) {
  return linkPath === locationPath ? `${style.tab_item} ${style.tab_active}` : style.tab_item;
}

function getTabNavClass(linkPath, locationPath, itemName) {
  let activeClassName = "tab_" + itemName + "_active";
  let className = "tab_" + itemName;
  return linkPath === locationPath
    ? `${style.tab_item} ${style[activeClassName]}`
    : `${style.tab_item} ${style[className]}`;
}

const BottomNav = (props) => {
  let location = useLocation();
  console.log(location.pathname);
  return (
    <div class={style.container}>
      <MyNavLink to="/home">
        <div class={getTabNavClass("/home", location.pathname, "home")} />
      </MyNavLink>
      <MyNavLink to="/deposit">
        <div class={getTabNavClass("/deposit", location.pathname, "deposit")} />
      </MyNavLink>
      <MyNavLink to="/invite">
        <div class={getTabNavClass("/invite", location.pathname, "invite")} />
      </MyNavLink>
      <MyNavLink to="/withdraw">
        <div class={getTabNavClass("/withdraw", location.pathname, "withdraw")} />
      </MyNavLink>
      <MyNavLink to="/profile">
        <div class={getTabNavClass("/profile", location.pathname, "profile")} />
      </MyNavLink>
    </div>
  );
};

export default BottomNav;
